import getConfig from 'next/config'

const config = getConfig().publicRuntimeConfig

export const originalImage = (path = '') => `${config.cdnBasePath}/${path}`

export const thumbImage = (settings: string) => (path = '') => {
  if (path.startsWith(config.cdnBasePath)) {
    path = path.replace(`${config.cdnBasePath}/`, '')
  }
  return `${config.cdnBasePath}/${config.cdnThumbs}/${settings}/${path}`
}
